import { DataLineageNodeTypes } from '@y42/json-schema';
import { Binding, GraphObject, Margin, Panel, Picture, Size, Spot, TextBlock } from 'gojs';
import {
  dataLineageDiagramConfig,
  DataLineageUINode,
  LINEAGE_PARTS,
} from '../../../../../../state/data-lineage-diagram';
import { dataLineageNodeStatus } from '../../shared/parts/node-status';
import { subEntityTypeLogoTooltip } from '../../shared/parts/tooltips';
import { logoBinding, nameTextBinding, nameTextStrokeBinding } from '../../shared/utils/shared-bindings';

const $ = GraphObject.make;

export const nodeHeader = () =>
  $(
    Panel,
    Panel.Horizontal,
    {
      padding: new Margin(15, 5),
      alignment: Spot.Left,
      width: 290,
    },
    logo(),
    textBlock(),
    dataLineageNodeStatus([nodeStatusVisibilityBinding()]),
  );

const logo = (bindings: Binding[] = []) =>
  $(
    Picture,
    {
      name: LINEAGE_PARTS.NODE_LOGO_NAME,
      desiredSize: new Size(16, 16),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 5),
      toolTip: subEntityTypeLogoTooltip(),
    },
    logoBinding(),
    ...bindings,
  );

const textBlock = (bindings: Binding[] = []) =>
  $(
    TextBlock,
    {
      name: LINEAGE_PARTS.NODE_HEADER_NAME,
      overflow: TextBlock.OverflowClip,
      margin: new Margin(0, 5),
      alignment: Spot.Left,
      font: `${dataLineageDiagramConfig.font.style} ${dataLineageDiagramConfig.font.size.regular} ${dataLineageDiagramConfig.font.family}`,
      width: 220,
    },
    nameTextBinding(),
    nameTextStrokeBinding(),
    ...bindings,
  );

const nodeStatusVisibilityBinding = () =>
  new Binding('visible', '', (node: DataLineageUINode) => {
    return JobStatusEnabledNodes.includes(node.category);
  });

const JobStatusEnabledNodes = [
  DataLineageNodeTypes.Integration,
  DataLineageNodeTypes.UiModel,
  DataLineageNodeTypes.SqlModel,
  DataLineageNodeTypes.Export,
];
